export default __webpack_public_path__ + "static/media/hawaii.4c99e874.png";